module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_m.600f8a30b3a8f41972a270b12774f858.png";